// extracted by mini-css-extract-plugin
export default {"status":"styles_status__KlOJU","green_line":"styles_green_line__tJ2ny"};